var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 366.34 366.34",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00214e;}.cls-2{fill:#e18477;}.cls-3{fill:#a76962;}.cls-4{fill:#ff2609;}.cls-5{fill:none;stroke:#00214e;stroke-miterlimit:10;}.cls-6{fill:#ffffff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboards_Diversity_Avatars_by_Netguru") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.31,54.07c-12-4-24.85-7.28-37.54-5.85a115,115,0,0,0-55.55,22C93.33,94,85.13,137,71.81,172.53c-5,13.33-10,26.79-12.17,40.87-6.32,41.77,21.57,56.83,57.72,67.09,45.55,12.93,95.4,9.07,139.81-6.53,37.83-13.29,53-45.33,45-83.6-4-18.88-11.54-36.8-19.14-54.55C268.57,102.13,254.9,66.42,218.31,54.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.6,280.15a184.58,184.58,0,0,1-226.48-1l48.66-22.81a47.68,47.68,0,0,0,4.35-2.34l1.12-.7c.4-.25.79-.51,1.18-.78A46.54,46.54,0,0,0,151.1,236c4-7.55,5.32-15.88,5.38-24.38,0-5.73-.31-11.44-.37-17.18q-.06-4.75-.1-9.51l2,1,5.2,2.69,30.29,5.15,31.12,5.3.94,32L226,247l11.47,4.67,9,3.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M225.51,227.76c-2.72,1.68-5.29,2.47-7.54,2.23-14.79-1.59-43.64-13.18-61.8-34.63q0-1.58-.06-3.15-.06-4.76-.1-9.51l2,1,5.2,2.69,30.29,5.15,31.12,5.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M307.6,280.15a184.58,184.58,0,0,1-226.48-1l48.66-22.81q2.25-1.06,4.35-2.33c23.68,17.41,56.64,28.74,85.06,15.95,8.06-3.62,15.33-10,18.29-18.31l9,3.64Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 130.67,
    cy: 152.96,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 137.67,
    cy: 150.96,
    r: 17
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.67,217.09c-20.64,3.86-72-16.78-83.74-57.46a98.14,98.14,0,0,1-3.9-26.07c0-1.73,0-3.45.08-5.15,1.28-28.34,15.78-52,38.69-58.65,1.32-.38,2.65-.7,4-1a47.86,47.86,0,0,1,24,1.68,66.87,66.87,0,0,1,26.32,16.67,84.09,84.09,0,0,1,8.52,10,96.4,96.4,0,0,1,14.54,30.05C258,167.9,233.08,214.22,217.67,217.09Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.32,128.89a58,58,0,0,0,2,11.49c1,3.31,2.52,5.36,4.52,8.22a17.7,17.7,0,0,1,1.79,3c2.65,5.94-.86,12.53-7.54,12.53H210"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M195.34,156.45a3.4,3.4,0,0,0,2.11,6.38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218.05,116.61a31.19,31.19,0,0,1,22.85-2.16"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.58,119.5a36.76,36.76,0,0,1,31.23-1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.21,64.69c-9.92-1.93-21.82-1.59-31.55-1.47-5.31.06-10.69.4-15.75,2-14,4.51-23.11,18-28.79,31.6-1.45,3.47-16.44,38-16.11,38.07,9.6,3.12,19.88-1.22,28.89-5.75,26.74-13.47,55.12-35.12,66.62-63.74C212.45,65.16,211.34,64.91,210.21,64.69Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185,172.55a1.86,1.86,0,0,1,2.68-.5c2.08,1.46,5.88,4.56,11.28,5.64,7.36,1.46,13.75-1.48,15.27.41.86,1.07-.19,2.38-2.2,4.05a19.69,19.69,0,0,1-14.86,3.69c-7.08-1.33-12.4-9.53-12.4-12.43A1.72,1.72,0,0,1,185,172.55Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.41,130.89c6.1.05,6.1,9.37,0,9.42h-.27c-6.1-.05-6.1-9.37,0-9.42h.27Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.67,130.23c5.67,0,5.67,8.7,0,8.74h-.25c-5.67,0-5.67-8.7,0-8.74h.25Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.0d27541c242bed429ab08dc3549add4d.svg";
export { ForwardRef as ReactComponent };